import { render } from "./ReservationSystemComponent.vue?vue&type=template&id=40694ac8&scoped=true"
const script = {}

import "./ReservationSystemComponent.vue?vue&type=style&index=0&id=40694ac8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40694ac8"]])

export default __exports__